const loadMore = document.querySelector('.blog-template__load-more');
let currentPage = parseInt(loadMore?.getAttribute('data-page'));
let maxPage = parseInt(loadMore?.getAttribute('data-max-page'));
if (currentPage == maxPage) {
  loadMore.remove();
} else {
  btnViewMoreClick(loadMore);
}
function renderHTML(handle, nextPage, container, loadMore = undefined) {
  let newDiv = document.createElement("div");
  // Fetch the section
  let blogContent = fetch(window.Shopify.routes.root + `blogs/${handle}?page=${nextPage}&view=rework-blog&sections=blog-template-custom`);
  // Inject the section in the container
  blogContent.then(res => {
    res.json().then(content => {
      if (loadMore != undefined) {
        loadMore.remove();
      }
      newDiv.innerHTML = content['blog-template-custom'];
      container.appendChild(newDiv);
      const event = new Event('contentLoaded');
      container.dispatchEvent(event);
    });
  });
}
document.querySelector('.blog-page-custom-section')?.addEventListener('contentLoaded', () => {
  const loadMore = document.querySelector('.blog-template__load-more');
  let currentPage = parseInt(loadMore?.getAttribute('data-page'));
  let maxPage = parseInt(loadMore?.getAttribute('data-max-page'));
  if (currentPage == maxPage) {
    loadMore.remove();
  } else {
    btnViewMoreClick(loadMore);
  }
});
function btnViewMoreClick(loadMore) {
  let currentPage = parseInt(loadMore?.getAttribute('data-page'));
  let handleBlog = loadMore?.getAttribute('data-handle-blog');
  loadMore?.addEventListener('click', () => {
    renderHTML(handleBlog, currentPage + 1, document.querySelector('.blog-page-custom-section'), loadMore);
  });
}